import React from "react";
import {ResultManagerUserUIProvider} from "./ResultManagerUserUIContext";
import AddResultManagerUser from "./AddResultManagerUser";

export function ResultManagerUserPage() {
  return (
    <ResultManagerUserUIProvider>
      <AddResultManagerUser />
    </ResultManagerUserUIProvider>
  );
}
